import { render, staticRenderFns } from "./NavigationSidebar.vue?vue&type=template&id=3cd31e1d&scoped=true"
import script from "./NavigationSidebar.vue?vue&type=script&lang=ts"
export * from "./NavigationSidebar.vue?vue&type=script&lang=ts"
import style0 from "./NavigationSidebar.vue?vue&type=style&index=0&id=3cd31e1d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd31e1d",
  null
  
)

export default component.exports